<script>
import {defineComponent, ref, computed} from "vue";
import {useStore} from "vuex";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";

export default defineComponent({
  components: {DataTable, Column, Dropdown},
  props: {
    locations: {
      type: Array,
      required: true
    },
    locationTypes: {
      type: Array,
      required: true,
    }
  },
  emits: ['toggleChangePointType'],
  setup(props, {emit}) {
    const points = ref(props.locations);
    const types = ref([...props.locationTypes]);
    const store = useStore();
    const lang = computed(() => store.getters.getLang);

    const change = ({id, point_type_id}) => {
      emit('toggleChangePointType', {id, point_type_id});
    };

    return {change, points, types, lang};
  }
});
</script>

<template>
  <DataTable :value="points" showGridlines selectionMode="single">
    <Column :field="`name_${lang}`" header="Название точки"></Column>
    <Column :field="`address_${lang}`" header="Адрес"></Column>
    <Column field="type" header="Тип точки">
      <template #body="slotProps">
        <Dropdown
            @change="change(slotProps.data)"
            v-model="slotProps.data.point_type_id"
            :options="types"
            optionValue="id"
            :optionLabel="lang === 'ru' ? 'name_ru' : 'name_en'"
            placeholder="Тип точки"
            class="w-full"
        />
      </template>
    </Column>
    <Column field="lat" header="Широта"></Column>
    <Column field="lon" header="Долгота"></Column>
  </DataTable>
</template>